import { useAuth } from "../../context/AuthContext";
import CommunityTab from "../bedrijf/CommunityTab";
import BottomNav from "../../components/ui/BottomNav";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CommunityPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#080808]">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-[#080808] border-b border-white/5 px-4 py-3 flex items-center gap-3">
        <button onClick={() => navigate("/account")} className="text-zinc-500 hover:text-white transition-colors p-1">
          <ArrowLeft size={18} />
        </button>
        <h1 className="text-white font-bold text-sm">Community</h1>
      </div>

      <div className="px-4 py-6 max-w-2xl mx-auto pb-24">
        <CommunityTab
          token={user?.token}
          currentUserId={user?.id || user?._id}
          currentRole={user?.role || "sporter"}
        />
      </div>
      <BottomNav />
    </div>
  );
}
